// extracted by mini-css-extract-plugin
export default {"symbol":"Kwvcly5dXBttpEuIkNFD"};